import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "./styles.less";
// import { useTranslation } from "react-i18next";
import { CommonBlogRqcode } from "../common-blog-rqcode";
import { blogAxios } from "../../utils/blogAxios";
import { CommonBlogTag } from "../common-blog-tag";
// import { CommonBlogForm, CommonBlogRegister } from "../common-blog-register";

// const seriesArticle = [
//   {
//     imgurl: "//files.authing.co/authing-website/blog-sample-aws.jpeg",
//     title: "单点登录那些事儿",
//     content: "单点登录那些事儿（一）应用与…",
//     link: "",
//   },
//   {
//     imgurl: "//files.authing.co/authing-website/blog-sample-ali.jpeg",
//     title: "单点登录那些事儿",
//     content: "单点登录那些事儿（一）应用与…",
//     link: "",
//   },
//   {
//     imgurl: "//files.authing.co/authing-website/blog-sample-aws.jpeg",
//     title: "单点登录那些事儿",
//     content: "单点登录那些事儿（一）应用与…",
//     link: "",
//   },
// ];
export const BlogHomeAside = ({ recommends: serverRecommends }) => {
  //   const { t } = useTranslation();
  const [recommends, setRecommend] = useState(serverRecommends || []);

  useEffect(() => {
    blogAxios.get("/recommends").then(({ data }) => {
      setRecommend(data);
    });
  }, []);

  return (
    <section
      style={{
        marginLeft: 62,
        minWidth: 340,
        width: 340,
      }}
    >
      <div className="blog-home-aside">
        <div className="rank">
          <div className="title">推荐阅读</div>
          {recommends.map(({ article }, index) => {
            return (
              <Link to={`/blog/${article.id}`} key={index} className="item">
                <span className="order">{index + 1}</span>
                <span className="article-title">{article.title}</span>
              </Link>
            );
          })}
        </div>
        {/* <CommonBlogRegister /> */}
        <CommonBlogRqcode />
        {/* <CommonBlogForm /> */}
        <CommonBlogTag />
      </div>
    </section>
  );
};
